<template>
  <el-dialog
    :title="isEdit ? '编辑工具' : '新增工具'"
    :visible.sync="visible"
    width="560px"
    append-to-body
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="100px">
      <el-form-item label="工具名称" prop="toolName">
        <el-input
          v-model="form.toolName"
          placeholder="请输入工具名称"
          maxlength="200"
          show-word-limit
        />
      </el-form-item>
      <el-form-item label="工具类型" prop="toolType">
        <dict-select
          :key="toolTypeDictSelectKey"
          v-model="form.toolType"
          :dict-type="DICT_TYPE.TOOL_TYPE"
          placeholder="请选择工具类型"
          style="width: 100%"
        />
        <div class="dict-empty-hint">
          如需维护工具类型，可前往
          <el-button type="text" class="dict-empty-hint-link" @click="goDictManage(DICT_TYPE.TOOL_TYPE)">字段管理</el-button>
          菜单中新增或修改。
        </div>
      </el-form-item>
      <el-form-item label="总数量" prop="totalCount">
        <el-input-number
          v-model="form.totalCount"
          :min="1"
          :precision="0"
          placeholder="请输入总数量"
          style="width: 100%"
        />
      </el-form-item>
      <el-form-item label="存放位置">
        <el-input v-model="form.storageLocation" placeholder="请输入存放位置" maxlength="200"/>
      </el-form-item>
      <el-form-item label="备注">
        <el-input v-model="form.remark" type="textarea" :rows="3" placeholder="备注信息" maxlength="500" show-word-limit/>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" :loading="loading" @click="handleSubmit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
// 服务
import { toolService } from './tool.service';
// 工具函数
import { DICT_TYPE } from '@/features/components/dict/dictTypeKeys';

export default {
  name: 'ToolDialog',
  data () {
    return {
      DICT_TYPE,
      toolTypeDictSelectKey: 0,
      visible: false,
      loading: false,
      isEdit: false,
      form: {
        uuid: null,
        toolName: '',
        toolType: '',
        totalCount: 1,
        storageLocation: '',
        remark: ''
      },
      rules: {
        toolName: [{ required: true, message: '请输入工具名称', trigger: 'blur' }],
        totalCount: [{ required: true, message: '请输入总数量', trigger: 'blur' }]
      }
    };
  },
  methods: {
    goDictManage (dictType) {
      this.visible = false;
      const query = dictType ? { dictType } : {};
      this.$nextTick(() => {
        this.openNavTab({ name: 'dictList', query });
      });
    },
    open (row) {
      this.toolTypeDictSelectKey += 1;
      this.visible = true;
      this.isEdit = !!row;
      if (row) {
        this.form = {
          uuid: row.uuid,
          toolName: row.toolName,
          toolType: row.toolType || '',
          totalCount: row.totalCount || 1,
          storageLocation: row.storageLocation || '',
          remark: row.remark || ''
        };
      } else {
        this.resetForm();
      }
    },
    resetForm () {
      this.form = { uuid: null, toolName: '', toolType: '', totalCount: 1, storageLocation: '', remark: '' };
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate());
    },
    handleClose () {
      this.visible = false;
      this.resetForm();
    },
    handleSubmit () {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        this.loading = true;
        const request = this.isEdit
          ? toolService.updateTool(this.form)
          : toolService.saveTool(this.form);

        request.then(() => {
          this.$message.success(this.isEdit ? '编辑成功' : '新增成功');
          this.handleClose();
          this.$emit('success');
        }).finally(() => {
          this.loading = false;
        });
      });
    }
  }
};
</script>

<style scoped lang="scss">
.dict-empty-hint {
  margin-top: 4px;
  font-size: 12px;
  color: #909399;
  line-height: 1.5;
}

.dict-empty-hint-link {
  padding: 0;
  vertical-align: baseline;
  font-size: 12px;
}
</style>
